// Copyright 2026. WebPros International GmbH. All rights reserved.

import * as React from 'react';
import {
    Alert,
    Translate,
} from '@plesk/ui-library';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { pathTo } from 'common/helpers/core';
import { INTENT_TYPE } from 'common/constants';
import { RootState } from 'admin/core/store';
import { hasPermission } from 'common/modules/permission/selectors';
import { PERMISSION_LIST } from 'common/modules/permission/constants';

export interface IHighAvailabilityDisabledAlertProps {
    canManageSettings: boolean;
}

export const HighAvailabilityDisabledAlert: React.FC<IHighAvailabilityDisabledAlertProps> = ({
    canManageSettings,
}) => (
    <Alert intent={INTENT_TYPE.WARNING}>
        <Translate content="highAvailability.disabledAlert.description" />
        {canManageSettings && (
            <>
                {' '}
                <Link to={pathTo('settings/high_availability')}>
                    <Translate content="highAvailability.disabledAlert.link" />
                </Link>
            </>
        )}
    </Alert>
);

const mapStateToProps = (state: RootState) => ({
    canManageSettings: hasPermission(state, PERMISSION_LIST.MANAGE_APP_SETTINGS),
});

export default connect(mapStateToProps)(HighAvailabilityDisabledAlert);
